import * as React from "react";
import { useEffect, useRef, useState } from "react";
import Cookies from "js-cookie";
import axios from "axios";
import { BASE_URL } from "../../Landing/Components/Api/Api";
import Button from "react-bootstrap/Button";
import { Controller, useForm } from "react-hook-form";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "ckeditor5-custom-build";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";
import { InputFormat } from "../../Landing/Components/FormOptions/InputFormat";
import DataTableTemplate from "../Components/DataTableTemplate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { PanelContainer } from "../Components/PanelContainer";
import { fetchData } from "../Components/Utilities";
import Swal from "sweetalert2";

export const ControlSidebar = () => {
  const [defaultDatatableRows, setDefaultDatatableRows] = useState(10);
  const [defaultRows, setDefaultRows] = useState(20);
  const [lazyState, setLazyState] = useState({
    first: 0,
    page: 0,
    rows: defaultRows,
  });
  const [totalRecords, setTotalRecords] = useState(0);
  const [sidebarMenu, setSidebarMenu] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [showEditComponent, setShowEditComponent] = useState(false);

  useEffect(() => {
    const bodyFormData = new FormData();
    bodyFormData.append("guid", Cookies.get("guid"));
    fetchData("sidebar", bodyFormData, handleApiResponse);
  }, []);
  const handleApiResponse = (data) => {
    setSidebarMenu(data?.dt);
    setTotalRecords(data?.dt?.length);
  };
  const cols = [
    {
      field: "id",
      header: "ردیف",
      body: (data, options) => options.rowIndex + 1,
    },
    {
      field: "title",
      header: "عنوان",
    },
    {
      field: "CityName",
      header: "ویرایش",
      body: (data, options) => (
        <div className="my-1">
          <FontAwesomeIcon
            icon={"edit"}
            onClick={() => handleOpeEditItem(data)}
            className="icon-sm   prime-bg text-white p-1 text-center rounded"
            color="gray"
          />
        </div>
      ),
    },
  ];

  const toast = useRef(null);
  const defaultValues = {
    persianTitle: "",
    englishTitle: "",
    sort: "",
    id: "",
    txt: "",
  };
  const accept = () => {
    toast.current.show({
      severity: "info",
      summary: "تایید شد",
      detail: "درخواست شما انجام شد",
      life: 3000,
    });
  };

  const reject = () => {
    toast.current.show({
      severity: "warn",
      summary: "لغو شد",
      detail: "درخواست حذف لغو شد",
      life: 3000,
    });
  };

  const schema = yup.object({
    persianTitle: yup
      .string()
      .required("عنوان وارد نشده است.")
      .min(4, "عنوان انتخاب شده نباید کمتر از 4 کاراکتر باشد."),
  });
  const {
    handleSubmit,
    control,
    reset,
    setValue,
    register,
    formState: { errors },
  } = useForm({ defaultValues, resolver: yupResolver(schema) });

  const handleOpeEditItem = (data) => {
    setShowEditComponent(true);
    if (data) {
      setIsEditMode(true);
      const { title, ...otherData } = data;
      const [englishTitle, persianTitle] = title.split("|");
      reset({
        ...defaultValues,
        ...otherData,
        persianTitle,
        englishTitle,
      });
    } else {
      setIsEditMode(false);
      reset(defaultValues);
    }
  };
  const handleOpeDeleteItem = async (id) => {
    console.log(id);
    const bodyFormData = new FormData();
    bodyFormData.append("id", id);
    try {
      const responseGlobal = await axios.post(BASE_URL, bodyFormData, {
        headers: {
          cmd: "deletesidebar",
          "Content-Type": "multipart/form-date",
        },
      });
      if (responseGlobal.status === 200) {
        if (responseGlobal?.data?.UserId === "0") {
        }
        toast.current.show({
          severity: "info",
          summary: "تایید شد",
          detail: "درخواست شما انجام شد",
          life: 3000,
        });
        fetchData("sidebar", bodyFormData, handleApiResponse);
      } else {
        console.error(
          `API request failed with status: ${responseGlobal.status}`
        );
      }
    } catch (error) {
      throw new Error("control sidebar route Error: ", error.message);
    }
  };

  const handleDelete = (id) => {
    Swal.fire({
      show: true,
      title: "حذف آیتم",
      text: "آیا می خواهید آیتم را حذف کنید؟",
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: "بله",
      cancelButtonText: "خیر",
      cancelButtonColor: "#d33",
      icon: "success",
    }).then(async (result) => {
      if (result.isConfirmed) {
        await handleOpeDeleteItem(id);
      }
    });
  };

  const onpage = (event) => {
    setLazyState({
      first: event.first,
      rows: event.rows,
      page: event.page,
    });
    setDefaultRows(event.rows);
  };

  const onSubmit = async (data) => {
    const bodyFormData = new FormData();
    bodyFormData.append("id", data?.id ?? 0);
    bodyFormData.append("title", `${data?.englishTitle}|${data?.persianTitle}`);
    bodyFormData.append("txt", data?.txt);
    bodyFormData.append("sort", data?.sort);
    bodyFormData.append("guid", Cookies.get("guid"));
    try {
      const responseGlobal = await axios.post(BASE_URL, bodyFormData, {
        headers: {
          cmd: "sidebarupdate",
          "Content-Type": "multipart/form-date",
        },
      });
      if (responseGlobal.status === 200) {
        const data = responseGlobal.data;
        fetchData("sidebar", bodyFormData, handleApiResponse);
      } else {
        console.error(
          `API request failed with status: ${responseGlobal.status}`
        );
      }
    } catch (error) {
      console.error("Error while fetching menu data:", error);
    }
  };

  return (
    <PanelContainer title={"کاربران"}>
      <Toast ref={toast} />
      <ConfirmDialog />
      <DataTableTemplate
        lazyState={lazyState}
        // select='select'
        className={"table-border"}
        columns={cols}
        list={sidebarMenu}
        totalRecords={totalRecords}
        setlazyState={setLazyState}
        setDefaultDatatableRows={setDefaultDatatableRows}
        defaultDatatableRows={defaultDatatableRows}
        width="25rem"
      />
      <div className="col-6 mt-5 mb-5">
        <Button className="" onClick={() => handleOpeEditItem()}>
          افزودن
        </Button>
      </div>
      {showEditComponent && (
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="panel-heading prime-bg text-white text-center py-2">
            <span id="ContentPlaceHolder1_lblbannerheading ">
              {isEditMode ? "ویرایش ویژگی" : "افزودن ویژگی جدید"}
            </span>
          </div>
          <div className="panel-body">
            <div className="edit row">
              <div className="col-12 col-lg-6">
                <InputFormat
                  control={control}
                  name="sort"
                  type={"tel"}
                  defaultValue={""}
                  label="اولویت"
                  errors={errors}
                />
              </div>
              <div className="col-12 col-lg-6">
                <InputFormat
                  control={control}
                  name="persianTitle"
                  type={"text"}
                  label="عنوان فارسی"
                  errors={errors}
                  required={true}
                />
              </div>
            </div>

            <div className="edit row">
              <div className="col-12 col-lg-6">
                <InputFormat
                  control={control}
                  name={`englishTitle`}
                  type={"text"}
                  label="عنوان انگلیسی"
                  errors={errors}
                />
              </div>
            </div>
            <div id="your-editor-container">
              <Controller
                control={control}
                render={({ field }) => (
                  <CKEditor
                    {...field}
                    className={"overflow-scroll h-100"}
                    editor={ClassicEditor}
                    data={field.value}
                    // onReady={editor => {
                    //     console.log('Editor is ready to use!', editor);
                    // }}

                    onChange={(event, editor) => {
                      const data = editor.getData();
                      field.onChange(data);
                    }}
                  />
                )}
                name={"txt"}
              />
            </div>
            <div className="row">
              <div className="col-6 mt-2">
                <Button type="submit">ذخیره</Button>
              </div>
            </div>
          </div>
        </form>
      )}
    </PanelContainer>
  );
};
